var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccumulate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M24.375 0H1.625A1.63 1.63 0 0 0 0 1.625v22.75A1.63 1.63 0 0 0 1.625 26h22.75A1.63 1.63 0 0 0 26 24.375V1.625A1.63 1.63 0 0 0 24.375 0zM11 18H8v-8h3v8zM4 4h2v18H4V4zm2 16h16v2H6v-2zm10-2h-3V5h3v13zm5 0h-3v-7h3v7z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccumulate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/accumulate.a7deaae44cb03a1f5fc2c4440603e405.svg";